import React, {useEffect} from 'react'
import PageSpinner from '../components/PageSpinner/PageSpinner'
import {isIOS, isAndroid} from '../util'
import {WEB_BASE} from './util'

const RedirectToApp = () => {
    useEffect(() => {
        if (isIOS) {
            window.location = 'https://itunes.apple.com/za/app/names-faces/id949875464'
        } else if (isAndroid) {
            window.location = 'https://play.google.com/store/apps/details?id=za.co.polymorph.namesfaces'
        } else {
            window.location = WEB_BASE
        }
    }, [])

    return <PageSpinner />
}

export default RedirectToApp
